import React from 'react'
import LayoffPage from '../Homepage/LayoffPage'

function Layoff() {
  return (
    <>
        <LayoffPage />
    </>
  )
}

export default Layoff
